import { FC, memo } from 'react';

import { useForm } from 'react-hook-form';

import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import { usePasswordRecovery } from '~/modules/auth/hooks/usePasswordRecovery';

import { FormGroup } from '~/shared/components/Form/FormGroup';
import { ControlledCustomRadioSelector } from '~/shared/components/Form/ControlledCustomRadioSelector';

import { passwordRecoveryMethodsOptions } from '~/modules/auth/assets/data/passwordRecoveryMethodsOptions';

import { IPasswordRecoveryFormData } from '~/modules/auth/interfaces/IPasswordRecoveryFormData';

import { StepWrapper } from '../StepWrapper';

const formSchemaValidation = Yup.object().shape({
  method: Yup.string()
    .required('Selecione uma forma de recuperação')
    .nullable(),
});

const BaseStepOne: FC = () => {
  const { nextStep } = usePasswordRecovery();

  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm<Pick<IPasswordRecoveryFormData, 'method'>>({
    resolver: yupResolver(formSchemaValidation),
    defaultValues: { method: null },
  });

  return (
    <StepWrapper step={1} onSubmit={handleSubmit(nextStep)}>
      <FormGroup>
        <ControlledCustomRadioSelector
          control={control}
          name="method"
          options={passwordRecoveryMethodsOptions}
          error={errors.method}
        />
      </FormGroup>
    </StepWrapper>
  );
};

export const StepOne = memo(BaseStepOne);
